/**
 * Contact & tracking settings — the only place to fill in.
 * Any empty value is simply not displayed (no placeholder ever reaches the site).
 *
 *  phone       E.164 format for the tel: link, e.g. '+15145551234'
 *  phoneLabel  as displayed, e.g. '514 555-1234'
 *  email       e.g. 'ventes@bciti.ai'
 *  bookingUrl  scheduling link (Calendly, Microsoft Bookings, HubSpot…), e.g. 'https://calendly.com/…'
 *  gtmId       Google Tag Manager container, e.g. 'GTM-ABC1234'
 *  sameAs      official public profiles (used in structured data only)
 */
export const contact = {
  phone: '',
  phoneLabel: '',
  email: 'ventes@bciti.ai',
  bookingUrl: '',
  gtmId: 'GTM-MXPWKGHB',
  sameAs: [] as string[],
}

export const hasPhone = () => Boolean(contact.phone && contact.phoneLabel)
export const hasEmail = () => Boolean(contact.email)
export const hasBooking = () => /^https:\/\//.test(contact.bookingUrl)
export const hasAnyContact = () => hasPhone() || hasEmail() || hasBooking()
